<template>
  <div
    v-if="isVisible"
    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center p-4"
  >
    <div class="confirm-dialog max-w-[512px] w-full shadow-lg rounded-md bg-white">
      <h3 class="ml-6 mt-7 mb-5">
        {{ $t('messages.passwordless.confirm_modal.title') }}
      </h3>
      <p class="b1 ml-6 mr-6 text-zyxel-gray-800">
        {{ $t('messages.passwordless.confirm_modal.description') }}
      </p>
      <div class="hidden sm:flex justify-end space-x-2 mr-6 mt-6 mb-5">
        <button
          class="min-w-[120px] button-cancel"
          @click="handleCancel"
        >
          {{ $t('messages.button.cancel') }}
        </button>
        <button
          class="min-w-[120px] button-primary"
          @click="handleConfirm"
        >
          {{ $t('messages.button.confirm') }}
        </button>
      </div>
      <div class="flex-col sm:hidden mt-8 p-6">
        <button
          class="button-primary w-full mb-4"
          @click="handleConfirm"
        >
          {{ $t('messages.button.confirm') }}
        </button>
        <button
          class="button-cancel w-full mb-6"
          @click="handleCancel"
        >
          {{ $t('messages.button.cancel') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordlessConfirmModal',
  props: {
    isVisible: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    handleCancel() {
      this.$emit('close-modal');
    },
    handleConfirm() {
      this.$emit('confirm');
    }
  }
}
</script>
